export enum FILTER_TYPE {
  ESTADO = 'estado',
  RESPONSABLE = 'Responsable',
  ROL = 'Rol',
  NIVEL = 'Nivel',
  TIME = 'timestamp',
  WORKFLOW = 'workflowInicial',
}
